import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRICS]: {
		url:'/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/:calculationMaterialsMetricId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/:calculationMaterialsMetricId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/:calculationMaterialsMetricId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].CREATE_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: {
		url:'/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/:calculationMaterialsMetricId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC_BULK_UPDATE]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/bulk_update/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PUT_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/:calculationMaterialsMetricId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].DELETE_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/calculation_materials_metrics/:calculationMaterialsMetricId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}